import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/store";
import {
  CanalAnonimo,
  Comissoes,
  Efetividade,
  listEmails,
  listContingency,
  Queries,
  Tools,
  Reclamacoes,
  Usuario,
  Usuarios,
  admConf,
  ListClient,
  Avisos
} from "./all-components";
import BIChatsSuporte from "./views/tools/BIChatsSuporte.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      name: "Main",
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "./containers/Main.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/canalanonimo",
          name: "faleGestao",
          meta: {
            module: "Fale com a Gestão"
          },
          component: CanalAnonimo,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module) {
                next();
              }
            });
          }
        },

        {
          path: "/usuarios",
          name: "AdmUsuarios",
          meta: {
            module: "Administração",
            name: "Usuários"
          },
          component: Usuarios,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/usuario/:id?",
          name: "admUsuario",
          component: Usuario,
          props: true,
          meta: {
            module: "Administração",
            name: "Usuários",
            parent: "usuarios"
          },
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (
                (item.label == to.meta.module && item.value == to.meta.name) ||
                to.params.id == store.getters.idUser
              ) {
                next();
              }
            });
          }
        },

        {
          path: "/avisos",
          name: "notificacao",
          meta: {
            module: "Gestão",
            name: "Notificação"
          },
          component: Avisos,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/configuracoes",
          name: "admConfiguracoes",
          meta: {
            module: "Administração",
            name: "Configurações"
          },
          component: admConf,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/reclamacoes",
          name: "reclamacoes",
          meta: {
            module: "Gestão",
            name: "Reclamações"
          },
          component: Reclamacoes,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/clientes/cadastro",
          name: "cliCadastro",
          meta: {
            module: "Clientes",
            name: "Cadastro"
          },
          component: ListClient,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/gestao/comercial/comissoes",
          name: "comissoes",
          meta: {
            module: "Comercial",
            name: "Comissões"
          },
          component: Comissoes,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/gestao/comercial/efetividade",
          name: "efetividade",
          meta: {
            module: "Comercial",
            name: "Efetividade"
          },
          component: Efetividade,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/emails",
          name: "emails",
          meta: {
            module: "Time de Apoio",
            name: "E-mails (Whitelist)"
          },
          component: listEmails,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },

        {
          path: "/contingencia",
          name: "contingencia",
          meta: {
            module: "Time de Apoio",
            name: "Contingência"
          },
          component: listContingency,
          beforeEnter: (to, from, next) => {
            next();
          }
        },

        {
          path: "/queries",
          name: "devQueries",
          meta: {
            module: "Desenvolvimento",
            name: "Queries"
          },
          component: Queries,
          beforeEnter: (to, from, next) => {
            store.getters.currentUser.permissao.filter(item => {
              if (item.label == to.meta.module && item.value == to.meta.name) {
                next();
              }
            });
          }
        },
        {
          path: "/help-queries",
          name: "ferramentas",
          meta: {
            module: "Ferramentas"
          },
          component: Tools,
        },
        {
          path: "/help-queries/support-chats-report",
          name: "relatorioChatsSuporte",
          meta: {
            module: "Ferramentas"
          },
          component: BIChatsSuporte,
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "./containers/Login.vue")
    },
    {
      path: "/error-404",
      name: "error",
      component: () =>
        import(/* webpackChunkName: "error" */ "./containers/Error404.vue")
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404"
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      return next();
    }
    return next({ path: "/login", query: { redirect: to.path } });
  } else if (to.fullPath === "/login" && store.getters.isLoggedIn) {
    return next({ path: "/" });
  }
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
